<template>
  <div
    class="status-card"
    v-if="
      order_status && order_status.order_system_status !== 'requires_acceptance'
    "
  >
    <div class="status-header">
      <h6>{{ _T(orderStatus(order_status.status)) }}</h6>
    </div>
    <div
      class="status-body"
      v-if="
        order_status.status !== 'delivered' &&
        order_status.status !== 'finished' &&
        order_status.order_system_status !== 'rejected'
      "
    >
      <div class="media" v-if="order_status.status === 'on-a-way'">
        <div class="pick-icon">
          <svg class="vehicle" height="34" width="34" fill="none">
            <use xlink:href="#vehicle" />
          </svg>
        </div>
        <div class="media-body">
          <h4>{{ _T(orderStatus(order_status.status)) }}</h4>
          <h5 class="mb-0">{{ _T('You will receive your order soon') }}</h5>
        </div>
        <div class="timeing">
          <h5 v-html="deliveryTime"></h5>
        </div>
      </div>
      <div class="media" v-else-if="order_status.status === 'in-progress'">
        <div class="pick-icon">
          <svg class="fork-knife" height="34" width="34" fill="none">
            <use xlink:href="#fork-knife" />
          </svg>
        </div>
        <div class="media-body">
          <h4>{{ _T(orderStatus(order_status.status)) }}</h4>
          <h5 class="mb-0">{{ _T('Preparing your order') }}</h5>
        </div>
        <div class="timeing">
          <h5 v-html="deliveryTime"></h5>
        </div>
      </div>
      <div class="media" v-else>
        <div class="pick-icon">
          <svg class="pick-card" height="34" width="34" fill="none">
            <use xlink:href="#pick-card" />
          </svg>
        </div>
        <div class="media-body">
          <h4>{{ _T('Picking up food') }}</h4>
          <h5 class="mb-0">{{ _T('Order will be picked soon') }}</h5>
        </div>
        <div class="timeing">
          <h5 v-html="deliveryTime"></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Delivery from '@/mixins/Delivery'

export default {
  mixins: [Delivery],
  computed: {
    ...mapGetters(['_T', 'orderStatus']),
    ...mapState({
      order_status: (state) => state.tracking_store.order_status,
      driverInformation: (state) => state.tracking_store.driverInformation,
    }),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .status-card {
    .status-header {
      h6 {
        text-align: right;
      }
    }
  }
}
.status-card {
  border: $px1 dashed $warning-color;
  border-radius: $px4;
  width: $px435;
  @media (max-width: 575) {
    border-top: $px12 solid $light-border;
    border-radius: 0;
  }
  .status-header {
    padding: calc(#{$px8} + (10 - 8) * ((100vw - #{$px320}) / (1920 - 320)))
      calc(#{$px6} + (8 - 6) * ((100vw - #{$px320}) / (1920 - 320)));
    background-color: rgba(var(--color-warning-color-source), 0.5);
    border-bottom: $px1 dashed $warning-color;
    h6 {
      margin-bottom: 0;
      letter-spacing: 0.5px;
      color: $font-color;
    }
  }
  .status-body {
    padding: calc(#{$px10} + (15 - 10) * ((100vw - #{$px320}) / (1920 - 320)));
    .media {
      align-items: center;
      .pick-icon {
        width: $px60;
        height: $px60;
        background-color: $warning-color;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
      }
      h6 {
        margin-bottom: 0;
      }
      .timeing {
        h5 {
          margin-bottom: 0;
          font-weight: bold;
          letter-spacing: 0.005em;
          color: rgba($black, 0.29);
          span {
            font-size: calc(
              #{$px30} + (48 - 30) * ((100vw - #{$px320}) / (1920 - 320))
            );
            line-height: calc(
              #{$px30} + (58 - 30) * ((100vw - #{$px320}) / (1920 - 320))
            );
            letter-spacing: 0.005em;
            font-weight: bold;
            color: $font-color;
          }
        }
      }
      .media-body {
        margin-left: calc(
          #{$px10} + (16 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
        h4 {
          margin-bottom: $px7;
          font-weight: 600;
        }
        h5 {
          letter-spacing: 0.005em;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .status-card {
    width: 100%;
  }
}
@media (max-width: 575px) {
  .status-card {
    .status-header {
      display: none;
    }
    .status-body {
      background-color: rgba(var(--color-warning-color-source), 0.15);
      .media {
        .pick-icon {
          width: $px40;
          height: $px40;
          img {
            width: $px26;
          }
        }
        .media-body {
          h4 {
            margin-bottom: 0;
          }
          h5 {
            color: rgba($black, 0.29);
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
